import get from 'lodash/get';

export default function isCreditCardFormModified(formData, defaultState) {
  const details = get(formData, 'paymentOption.details');

  if (details) {
    // todo verify location of address fields in paymentOption
    // to get actual address, might need extra request
    return formData.expirationYear !== details.expirationYear
      || formData.expirationMonth !== details.expirationMonth
      || formData.zipCode !== details.postalCode
      || formData.firstName !== details.firstName
      || formData.lastName !== details.lastName
      || formData.address1 !== details.address1
      || formData.city !== details.city
      || formData.stateAbbreviation !== details.stateAbbreviation
      || formData.countryAbbreviation !== details.countryAbbreviation
      || formData.phone !== details.phone;
  }

  return formData.cardNumber !== defaultState.cardNumber
    || formData.expirationYear !== defaultState.expirationYear
    || formData.expirationMonth !== defaultState.expirationMonth
    || formData.zipCode !== defaultState.zipCode
    || formData.firstName !== defaultState.firstName
    || formData.lastName !== defaultState.lastName
    || formData.address1 !== defaultState.address1
    || formData.city !== defaultState.city
    || formData.stateAbbreviation !== defaultState.stateAbbreviation
    || formData.countryAbbreviation !== defaultState.countryAbbreviation
    || formData.phone !== defaultState.phone;
}
